// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDevIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDevIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDevIconOutlined = function DrrpDevIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDevIconOutlinedSvg
  }));
};

DrrpDevIconOutlined.displayName = 'DrrpDevIconOutlined';
export default React.forwardRef(DrrpDevIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDevIconOutlined.js
// module id = 2560
// module chunks = 0